import { AdamedExpertExternalFault, RegisterDoctorCommand } from '@dreryk/egabinet-adamed-expert-frontend-api';

import { dispatchSnackbarNegativeEvent, FullscreenSpinner, ModalConfirmButton } from '@dreryk/react-components';
import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { createInterpolatedTranslationKey } from '@dreryk/react-common';
import { Slot } from '@dreryk/watermelon';

import { translationKeys } from './translations';
import { AdamedExpertRegisterFormBean, AdamedExpertRegisterFormRendererProps } from './AdamedExpertRegisterForm';

type AdamedExpertRegisterModalConfirmButtonProps = Pick<AdamedExpertRegisterFormRendererProps, 'handleSubmit'> & {
   onSuccess: VoidFunction;
};

const useAdamedExpertRegisterFormCommand = (
   options: Pick<AdamedExpertRegisterModalConfirmButtonProps, 'onSuccess'>
): UseCqrsCommandResult<string, AdamedExpertRegisterFormBean, AdamedExpertExternalFault> => {
   return useCqrsCommand<string, AdamedExpertRegisterFormBean, AdamedExpertExternalFault>(
      (parameters) => {
         const command = new RegisterDoctorCommand();
         command.password = parameters.password!;
         command.birthDate = parameters.birthDate!;
         command.phoneNumber = Slot.emptyIfNull(parameters.phoneNumber);
         command.rememberMe = parameters.rememberMe;
         command.consentIds = parameters.consents.filter((value) => value.selected).map((value) => value.id);
         return command;
      },
      {
         onSuccess: () => {
            options.onSuccess();
         },
         onFault: {
            'egabinet-adamed-expert-frontend-api:AdamedExpertExternalFault': ({ message }) => {
               dispatchSnackbarNegativeEvent(
                  createInterpolatedTranslationKey(translationKeys.externalSystemBusinessFault, {
                     messageFromAdamedExpert: message,
                  })
               );
            },
         },
      }
   );
};

export const AdamedExpertRegisterModalConfirmButton = (
   props: AdamedExpertRegisterModalConfirmButtonProps
): React.ReactElement => {
   const { executeAsync: adamedExpertRegister, loading } = useAdamedExpertRegisterFormCommand({
      onSuccess: props.onSuccess,
   });
   return (
      <>
         {loading ? <FullscreenSpinner label={translationKeys.loading} /> : null}
         <ModalConfirmButton
            testId='adamedExpertRegister'
            label={translationKeys.modal.register.register}
            onClick={props.handleSubmit(adamedExpertRegister)}
         />
      </>
   );
};
